<div *ngIf="noteBody$ | async as noteBody">
  <crm-collapsible-section [maxHeightPx]="100">
    <p class="note-body"><span [innerHtml]="noteBody | sanitizeHtml"></span></p>
  </crm-collapsible-section>
</div>
